// Bootstrap JS and CSS
import "bootstrap";
import "./../css/main.scss";

// Bootstrap Popover
import "./vendor/popover";

// Bootstrap Tooltip
import "./vendor/tooltip";

// Font-Awesome
import "./vendor/fa.all.min";

// Import our own JS
import "./vendor/hunter";

// Import our own JS
import "./vendor/snipquantity";
import "./vendor/snipcart";
